import Immutable from 'seamless-immutable';
import { compose, curry } from 'ramda';
import { ConfigCreditCheckReducer, CONFIG_INITIAL_STATE as CONFIG_CREDIT_CHECK_INITIAL_STATE } from './credit.check.reducer';
export var INITIAL_STATE = Immutable({
  creditCheck: CONFIG_CREDIT_CHECK_INITIAL_STATE
});
var curriedSetState = curry(function (path, childReducer, accessorFunc, action, parentState) {
  return parentState.setIn(path, childReducer(accessorFunc(parentState), action));
});
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return compose(setCustomerCreditCheckReducer(action))(state);
}
var setCustomerCreditCheckReducer = curriedSetState(['creditCheck'], ConfigCreditCheckReducer, function (state) {
  return state.creditCheck;
});